import { settings } from "app";

import { getToken } from "auth/dataProvider.utils";

export const getOptions = (operation, data, params) => {
  let options = {
    method: operation,
    headers: {
      "X-Session-Id": getToken() === "null" ? "toni" : getToken(),
    },
  };

  if (data && operation !== "GET") {
    if (
      params?.meta?.useFormData !== undefined ? params.meta.useFormData : data.file || settings.useFormDataDataProvider
    ) {
      let fileFormData = createFormData(data);
      options.body = fileFormData;
    } else {
      options.headers["Accept"] = "application/json";
      options.headers["Content-Type"] = "application/json";
      options.body = JSON.stringify(data);
    }
  } else {
    options.headers["Accept"] = "application/json";
    options.headers["Content-Type"] = "application/json";
  }

  return options;
};

const createFormData = dataObject => {
  const formData = new FormData();

  buildFormData(formData, dataObject);

  return formData;
};

export default createFormData;

const isFile = input => "File" in window && input instanceof File;
const isBlob = input => "Blob" in window && input instanceof Blob;

function buildFormData(formData, data) {
  Object.keys(data).forEach(key => {
    if (data[key] === undefined || data[key] === null) return;

    if (Array.isArray(data[key])) {
      buildArrayFormData(formData, data[key], key);
    } else if (data[key].rawFile) {
      formData.append(key, data[key].rawFile);
    } else if (data[key] instanceof Date) {
      formData.append(key, data[key].toISOString());
    } else if (typeof data[key] === "object") {
      buildObjectFormData(formData, data[key], key);
    } else {
      formData.append(key, data[key]);
    }
  });
}

const buildArrayFormData = (formData, data, parentKey) => {
  Object.keys(data).forEach(key => {
    if (!data[key]) return;

    if (data[key].rawFile) {
      buildObjectFormData(formData, data[key], `${parentKey}[${key}]`);
    } else if (typeof data[key] === "object") {
      buildObjectFormData(formData, data[key], `${parentKey}[${key}]`);
    } else {
      formData.append(parentKey, data[key]);
    }
  });
};

const buildObjectFormData = (formData, data, parentKey) => {
  Object.keys(data).forEach(key => {
    if (!data[key]) return;

    if (Array.isArray(data[key])) {
      buildArrayFormData(formData, data[key], `${parentKey}[${key}]`);
    } else if (data[key].rawFile === "") {
      formData.append(`${parentKey}.${key}`, "");
    } else if (isFile(data[key]) || isBlob(data[key])) {
      formData.append(`${parentKey}.${key}`, data[key]);
    } else if (typeof data[key] === "object") {
      buildObjectFormData(formData, data[key], `${parentKey}[${key}]`);
    } else {
      formData.append(`${parentKey}[${key}]`, data[key]);
    }
  });
};
